import { render, staticRenderFns } from "./modifProduct.vue?vue&type=template&id=60f9722e"
import script from "./modifProduct.vue?vue&type=script&lang=ts"
export * from "./modifProduct.vue?vue&type=script&lang=ts"
import style0 from "./modifProduct.vue?vue&type=style&index=0&id=60f9722e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports